var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "rotate(30 10.098 15.294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 18a1.5 1.5 0 0 0 3 0M9 1.5a1.5 1.5 0 0 0-3 0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 3,
    x: 0.5,
    y: 14.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.5h-10V6.493a5 5 0 0 1 10 0z"
  }))));
};
export default SvgNotification;